const universalPrefix = window.location.pathname.startsWith('/2') ? '/2' : '';
const oldFrontendPrefix = '';
function simple(path) {
    const prefix = oldFrontendPrefix;
    return {
        prefix,
        path: `${prefix}${path}`,
        url: () => `${prefix}${path}`,
    };
}
function complex(config) {
    const prefix = config.prefix ?? oldFrontendPrefix;
    return {
        prefix,
        path: `${prefix}${config.path}`,
        url: (...args) => `${prefix}${config.url(...args)}`,
    };
}
export const AppRoutes = {
    dev: {
        designsystem: complex({
            prefix: universalPrefix,
            path: '/dev/designsystem',
            url: () => '/dev/designsystem',
        }),
    },
    common: {
        logout: simple('/logout'),
        terms: simple('/agb'),
        imprint: simple('/impressum'),
    },
    search: {
        redirect: complex({
            prefix: universalPrefix,
            path: `/suche`,
            url(postcode) {
                return `/suche/psychotherapeuten-in-${postcode}`;
            },
        }),
        therapist: complex({
            prefix: universalPrefix,
            path: `/suche/:cityslug`,
            url(city, searchParams) {
                const params = new URLSearchParams();
                const page = searchParams?.page ?? 1;
                if (page > 1) {
                    params.set('page', String(page));
                }
                if (searchParams?.sort) {
                    params.set('sort', searchParams.sort);
                }
                searchParams?.therapeuticFocus?.forEach(focus => {
                    params.append('therapeuticFocus', focus);
                });
                searchParams?.treatmentMethods?.forEach(method => {
                    params.append('treatmentMethods', method);
                });
                searchParams?.jobTitleTypes?.forEach(jobTitle => {
                    params.append('jobTitleTypes', jobTitle);
                });
                searchParams?.languages?.forEach(lang => {
                    params.append('languages', lang);
                });
                searchParams?.coverageTypes?.forEach(coverage => {
                    params.append('coverageTypes', coverage);
                });
                searchParams?.gender?.forEach(gender => {
                    params.append('gender', gender);
                });
                searchParams?.location?.forEach(location => {
                    params.append('location', location);
                });
                if (params.size > 0) {
                    return `/suche/psychotherapeuten-in-${city}?${params.toString()}`;
                }
                return `/suche/psychotherapeuten-in-${city}`;
            },
        }),
    },
    client: {
        therapist: {
            profile: complex({
                path: '/psychotherapie/:userId/:customerId',
                url({ userId, customerId }) {
                    return `/psychotherapie/${userId}/${customerId}`;
                },
            }),
            widget: complex({
                prefix: universalPrefix,
                path: '/appointment/widget/:userId/:customerId',
                url({ userId, customerId }) {
                    return `/appointment/widget/${userId}/${customerId}?noupdate`;
                },
            }),
        },
        invoice: {
            download: complex({
                prefix: universalPrefix,
                path: '/client/invoice/download/:token',
                url(token) {
                    return `/client/invoice/download/${token}`;
                },
            }),
        },
    },
};
//# sourceMappingURL=AppRoutes.mjs.map